<template>
    <hox-alert v-if="isVisible" type="warning" size="small" theme="dark" align-text="center">
        <template #content>
            <div class="missing-font-info">
                <p class="missing-font-info__message">
                    <strong>Some text fields are disabled due to missing fonts:</strong>
                    {{ missingFontNames.join(", ") }}
                </p>

                <Icon type="md-close" class="missing-font-info__close" @click="closedByUser = true" />
            </div>
        </template>
    </hox-alert>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import type { Editable } from "hoxton-types";

import * as editableUtils from "@/utils/editables";
import { EditorGetters, type Getters } from "@/store/modules/editor";

export default defineComponent({
    name: "MissingFontInfo",
    data() {
        return {
            closedByUser: false
        };
    },
    computed: {
        availableFontNames() {
            return Object.keys(this.fontsByName);
        },

        editableIds() {
            return this.$store.state.campaign.normalized.editableIds;
        },

        editables() {
            return this.$store.state.campaign.normalized.editables;
        },

        editablesForPSD() {
            return this.editableIds.reduce<Editable[]>((acc, editableId) => {
                if (editableUtils.hasPsdTemplate(this.editables[editableId]!, this.masterTemplates)) {
                    acc.push(this.editables[editableId]!);
                }

                return acc;
            }, []);
        },

        fontsByName() {
            return this.$store.getters[EditorGetters.fontsByName] as ReturnType<Getters["fontsByName"]>;
        },

        hasMissingFonts() {
            return !!this.missingFontNames.length;
        },

        isVisible() {
            return this.hasMissingFonts && !this.closedByUser;
        },

        masterTemplates() {
            return this.$store.state.campaign.normalized.masterTemplates;
        },

        missingFontNames() {
            const missingSet = this.editablesForPSD.reduce((acc, editable) => {
                const missing = editableUtils.findMissingFonts(editable, this.availableFontNames);

                missing.forEach(m => acc.add(m));

                return acc;
            }, new Set());

            return Array.from(missingSet) as string[];
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;
.missing-font-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.missing-font-info__message {
    font-size: 12px;
    vertical-align: center;
    color: $grey3;
}

.missing-font-info__close {
    cursor: pointer;
}
</style>
